import React, { useState } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Label,
    Input,
    Spinner
} from "reactstrap";
import { removeWithdrawalCoins } from "../../helpers/apis";
import { toast } from "react-toastify";

const RemoveCoinsModal = ({ isOpen, toggle, user, onSuccess }) => {
    const [amount, setAmount] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!amount || parseFloat(amount) <= 0) {
            toast.error("Please enter a valid amount");
            return;
        }

        if (parseFloat(amount) > (user?.currentCoins || 0)) {
            toast.error("Amount cannot exceed current coins");
            return;
        }

        if (!user?._id && !user?.id) {
            toast.error("User information is missing");
            return;
        }

        setLoading(true);
        try {
            const response = await removeWithdrawalCoins({
                userId: user._id || user.id,
                amount: parseFloat(amount)
            });

            // The axios interceptor returns response.data directly, so response is already the data object
            if (response && response.status === 1) {
                toast.success(response.message || "Coins removed successfully");
                setAmount("");
                if (onSuccess) onSuccess();
                toggle();
            } else {
                toast.error(response?.message || "Failed to remove coins");
            }
        } catch (error) {
            console.error("Error removing coins:", error);
            toast.error(error.message || "Failed to remove coins");
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        if (!loading) {
            setAmount("");
            toggle();
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={handleClose} className="modal-fixed-header-footer">
            <ModalHeader toggle={handleClose}>
                Remove Coins
            </ModalHeader>
            <form onSubmit={handleSubmit}>
                <ModalBody>
                    <div className="mb-3">
                        <Label className="form-label">
                            User <span className="text-danger">*</span>
                        </Label>
                        <Input
                            type="text"
                            value={user?.name || user?.email || 'N/A'}
                            disabled
                            className="bg-light"
                        />
                    </div>
                    <div className="mb-3">
                        <Label className="form-label">
                            Current Coins
                        </Label>
                        <Input
                            type="text"
                            value={user?.currentCoins || 0}
                            disabled
                            className="bg-light"
                        />
                    </div>
                    <div className="mb-3">
                        <Label className="form-label">
                            Amount to Remove <span className="text-danger">*</span>
                        </Label>
                        <Input
                            type="number"
                            min="0"
                            max={user?.currentCoins || 0}
                            step="0.01"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            placeholder="Enter amount"
                            required
                            disabled={loading}
                        />
                        <small className="text-muted">
                            Enter the number of coins to remove (Max: {user?.currentCoins || 0})
                        </small>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="secondary"
                        onClick={handleClose}
                        disabled={loading}
                    >
                        Cancel
                    </Button>
                    <Button
                        color="danger"
                        type="submit"
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <Spinner size="sm" className="me-2" />
                                Removing...
                            </>
                        ) : (
                            <>
                                Remove Coins
                            </>
                        )}
                    </Button>
                </ModalFooter>
            </form>
        </Modal>
    );
};

export default RemoveCoinsModal;

